// extracted by mini-css-extract-plugin
export default {"wrapper":"SingleDropDownPage_wrapper__CB9o1","wrapperDropDown":"SingleDropDownPage_wrapperDropDown__LkQ4C","errorMessage":"SingleDropDownPage_errorMessage__7Dkhq"};